<template>
  <div
    v-if="display"
    id="overlay"
    class="disable"
  >
    <div v-if="detailed" class="message">
      {{ $t(`disabled.text`) }}
      <b-btn
        v-if="!disabled"
        :to="btnLink"
        variant="primary"
        block
      >
        {{ $t('actions.activate') }}
      </b-btn>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DisabledOverlayComponent',
    props: {
      btnLink: {
        type: Object,
        default() {
          return { name: 'subscription.index', id: this.$route.params.id };
        },
      },
    },
    data() {
      return {
        display: false,
        disabled: false,
      };
    },
    mounted() {
      this.$bus.$on('t-event.get-memo.success', this.check);

      const { memorial } = this.get();
      if (memorial) {
        this.check(memorial);
      }
    },
    methods: {
      check(memorial) {
        const now = new Date();
        this.disabled = !memorial.enabled;
        this.detailed = !this.$root.$children[0].parametersNotCompleted;
        this.display = this.disabled || !this.detailed || (this.$route.name !== 'subscription.index' && this.$moment(now) > this.$moment(memorial.validity_date));
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';

  #overlay {
    background: rgba($black, .7);
    position: fixed;
    z-index: 99;
    left: 0;
    top: 144px;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;

    .message {
      background-color: $white;
      width: 50%;
      margin: auto;
      padding: 2rem;
      text-align: center;

      .btn {
        margin-top: 1rem;
      }
    }
  }

  @include editable-max-width(767px) {
    #overlay {
      top: 112px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DisabledOverlay.vue